var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-pre-plan-booking" } },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-dropdown",
                  {
                    class: _vm.btnCopyDisabled ? "not-click" : "",
                    attrs: { no: "1", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command1)
                      },
                      command: function(p) {
                        _vm.command1 = p
                        _vm.commandHandle(_vm.command1)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command1) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t(
                                "SeaExport.CopyLinkPromissoryNote"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyLinkPromissoryNote"))
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyLinkPublic")
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CopyLinkPublic")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-dropdown",
                  {
                    class: _vm.btnInvitationDisabled ? "not-click" : "",
                    staticStyle: { "margin-left": "5px" },
                    attrs: { no: "2", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command2)
                      },
                      command: function(p) {
                        _vm.command2 = p
                        _vm.commandHandle(_vm.command2)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command2) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t(
                                "SeaExport.InviteSupplementaryLinkPromissoryNote"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.InviteSupplementaryLinkPromissoryNote"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t(
                                "SeaExport.InviteSupplementaryLinksPublic"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.InviteSupplementaryLinksPublic"
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { no: "3", disabled: _vm.isEdit, type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.handleReceipt("sendLog")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.manifestQueryLog")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_TabPreBooking_unLock"],
                        expression: "['button_TabPreBooking_unLock']"
                      }
                    ],
                    staticStyle: { "margin-left": "5px" },
                    attrs: {
                      no: "4",
                      disabled: _vm.tempUnLockDisabled,
                      type: "primary"
                    },
                    on: { click: _vm.unLockManifestHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.manifestUnLockButton")))]
                ),
                _c(
                  "el-upload",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "5px"
                    },
                    attrs: {
                      disabled: _vm.excelImportDisabled,
                      data: {
                        importType: _vm.isSeaHouseChannel ? 1 : 0,
                        jobUuid: _vm.job.uuid,
                        mainifestInfoUuid: _vm.job.masterFlag
                          ? ""
                          : _vm.manifestInfo.uuid
                          ? _vm.manifestInfo.uuid
                          : _vm.manifestInfo.importTempUuid
                          ? _vm.manifestInfo.importTempUuid
                          : ""
                      },
                      action: _vm.URL.seaExport.manifestImportExcel,
                      headers: { sessionId: _vm.user.sessionId },
                      "show-file-list": false,
                      accept: ".xls, .xlsx",
                      "before-upload": _vm.beforeUpload,
                      "on-success": _vm.uploadSuccess
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          slot: "trigger",
                          disabled: _vm.excelImportDisabled,
                          type: "primary"
                        },
                        slot: "trigger"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                    )
                  ],
                  1
                ),
                _c(
                  "el-dropdown",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: {
                      no: "command4",
                      "split-button": "",
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command4)
                      },
                      command: function(p) {
                        _vm.command4 = p
                        _vm.commandHandle(_vm.command4)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command4) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.DownloadWseTemplate")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.DownloadWseTemplate"))
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.DownloadWseTemplateSh")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.DownloadWseTemplateSh"))
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t(
                                "SeaExport.ExportSinO56TemplateNb"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ExportSinO56TemplateNb"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isSeaHouseChannel || _vm.isWseChannel || _vm.isRongeTong
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.showShipGenerations }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ViewShipGenerations"))
                        )
                      ]
                    )
                  : _vm._e(),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.manifestCfmStateLog"))),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#7FA5DD",
                        cursor: "pointer",
                        "margin-left": "10px",
                        "margin-right": "10px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.cfmStateText))]
                  )
                ]),
                _c(
                  "el-radio",
                  {
                    attrs: {
                      no: "5",
                      disabled: _vm.isEdit || !_vm.manifestInfo.uuid,
                      label: 0
                    },
                    model: {
                      value: _vm.manifestType,
                      callback: function($$v) {
                        _vm.manifestType = $$v
                      },
                      expression: "manifestType"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.PreShippingBill")))]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: {
                      no: "6",
                      disabled: _vm.isEdit || !_vm.manifestInfo.uuid,
                      label: 1
                    },
                    model: {
                      value: _vm.manifestType,
                      callback: function($$v) {
                        _vm.manifestType = $$v
                      },
                      expression: "manifestType"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CleanShipping")))]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: {
                      no: "7",
                      disabled: _vm.isEdit || !_vm.manifestInfo.uuid,
                      label: 2
                    },
                    model: {
                      value: _vm.manifestType,
                      callback: function($$v) {
                        _vm.manifestType = $$v
                      },
                      expression: "manifestType"
                    }
                  },
                  [_vm._v("VGM")]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _c(
                      "el-menu",
                      {
                        staticClass:
                          "el-menu-button el-button el-button--primary el-button--mini",
                        class: _vm.popMenuDisabled ? "is-disabled" : "",
                        staticStyle: { "vertical-align": "bottom" },
                        attrs: {
                          "text-color": "#404144",
                          "active-text-color": "#404144",
                          mode: "horizontal"
                        },
                        on: { select: _vm.ediSendHandler }
                      },
                      [
                        _c(
                          "el-submenu",
                          {
                            attrs: {
                              index: "index",
                              disabled: _vm.popMenuDisabled
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "el-menu-btn-text",
                                attrs: { slot: "title" },
                                slot: "title"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.manifestType === 0
                                        ? _vm.isSeaHouseChannel ||
                                          _vm.isWseChannel ||
                                          _vm.isRongeTong
                                          ? _vm.$t(
                                              "SeaExport.PreShippingBillPperation"
                                            )
                                          : _vm.$t("SeaExport.PreShippingBill")
                                        : ""
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.manifestType === 1
                                        ? _vm.$t("SeaExport.CleanShipping")
                                        : ""
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.manifestType === 2 ? "VGM" : ""
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 0,
                                    expression: "manifestType === 0"
                                  }
                                ],
                                attrs: {
                                  index:
                                    _vm.isSeaHouseChannel ||
                                    _vm.isWseChannel ||
                                    _vm.isRongeTong
                                      ? _vm.$t("SeaExport.send")
                                      : _vm.$t("SeaExport.Original")
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isSeaHouseChannel
                                        ? _vm.$t("SeaExport.send")
                                        : _vm.$t("SeaExport.Original")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openBoolean,
                                      index: "API0"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: "FTP1", disabled: _vm.isHZ }
                                  },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 0,
                                    expression: "manifestType === 0"
                                  }
                                ],
                                attrs: {
                                  index:
                                    _vm.isSeaHouseChannel ||
                                    _vm.isWseChannel ||
                                    _vm.isRongeTong
                                      ? _vm.$t("SeaExport.change")
                                      : _vm.$t("SeaExport.Correct")
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isSeaHouseChannel
                                        ? _vm.$t("SeaExport.change")
                                        : _vm.$t("SeaExport.Correct")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: "FTP0", disabled: _vm.isHZ }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openBoolean || _vm.isHZ,
                                      index: "API1"
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 0,
                                    expression: "manifestType === 0"
                                  }
                                ],
                                attrs: {
                                  index:
                                    _vm.isSeaHouseChannel ||
                                    _vm.isWseChannel ||
                                    _vm.isRongeTong
                                      ? _vm.$t("SeaExport.deleteSingle")
                                      : _vm.$t("SeaExport.Delete")
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isSeaHouseChannel
                                        ? _vm.$t("SeaExport.deleteSingle")
                                        : _vm.$t("SeaExport.Delete")
                                    )
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: { index: "FTP2", disabled: _vm.isHZ }
                                  },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openBoolean || _vm.isHZ,
                                      index: "API2"
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.manifestType === 0 &&
                                      _vm.isSeaHouseChannel &&
                                      _vm.manifestInfo.seaHouseState === "23",
                                    expression:
                                      "manifestType === 0 && isSeaHouseChannel && manifestInfo.seaHouseState === '23'"
                                  }
                                ],
                                attrs: {
                                  index: _vm.isSeaHouseChannel
                                    ? _vm.$t("SeaExport.cancelBill")
                                    : _vm.$t("SeaExport.Delete")
                                }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.cancelBill")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openBoolean,
                                      index: "API3"
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 1,
                                    expression: "manifestType === 1"
                                  }
                                ],
                                attrs: { index: _vm.$t("SeaExport.Original") }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openClearBoolean,
                                      index: "API0"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "FTP1" } },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 1,
                                    expression: "manifestType === 1"
                                  }
                                ],
                                attrs: { index: _vm.$t("SeaExport.Correct") }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SeaExport.Correct")) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 2,
                                    expression: "manifestType === 2"
                                  }
                                ],
                                attrs: { index: _vm.$t("SeaExport.Original") }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openVGMBoolean,
                                      index: "API0"
                                    }
                                  },
                                  [_vm._v("API")]
                                ),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "FTP0" } },
                                  [_vm._v("FTP")]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manifestType === 2,
                                    expression: "manifestType === 2"
                                  }
                                ],
                                attrs: { index: _vm.$t("SeaExport.Correct") }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  { attrs: { index: "FTP1" } },
                                  [_vm._v("FTP")]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.openVGMBoolean,
                                      index: "API1"
                                    }
                                  },
                                  [_vm._v("API")]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isRongeTong && _vm.isQingDao,
                        expression: "isRongeTong && isQingDao"
                      }
                    ],
                    staticClass: "can-operate",
                    staticStyle: { "margin-left": "5px" },
                    attrs: { disabled: _vm.isEdit, type: "primary" },
                    on: { click: _vm.updateRongeTongKManifestConfig }
                  },
                  [_vm._v(_vm._s(_vm.$t("Message.UpdateVesselVoyNo")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong,
                        expression:
                          "isSeaHouseChannel || isWseChannel || isRongeTong"
                      }
                    ],
                    staticClass: "can-operate",
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.serviceInformation }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.OperationGuide")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.isSeaHouseChannel &&
                          !_vm.isWseChannel &&
                          !_vm.isRongeTong,
                        expression:
                          "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                      }
                    ],
                    staticStyle: { "vertical-align": "bottom" },
                    attrs: { no: "8", disabled: _vm.isEdit, type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.handleReceipt("receiptLog")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ediFeedBackState")))]
                ),
                _vm.isEdit
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary" },
                        on: { click: _vm.synchronizationHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong,
                        expression:
                          "isSeaHouseChannel || isWseChannel || isRongeTong"
                      },
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_SEBooking_ManifestModifyStatus"],
                        expression: "['button_SEBooking_ManifestModifyStatus']"
                      }
                    ],
                    staticStyle: { "margin-left": "5px" },
                    attrs: { disabled: _vm.isEdit, type: "primary" },
                    on: { click: _vm.modifyReceiptStatus }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ModifyStatus")))]
                ),
                _c("span", { staticStyle: { "margin-left": "10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.IsOrNotSpelling")))
                ]),
                _c(
                  "el-radio",
                  {
                    attrs: {
                      no: "9",
                      disabled: _vm.addSpellingDisabled,
                      label: false
                    },
                    model: {
                      value: _vm.job.spelling,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "spelling", $$v)
                      },
                      expression: "job.spelling"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.No")))]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: {
                      no: "10",
                      disabled: _vm.addSpellingDisabled,
                      label: true
                    },
                    model: {
                      value: _vm.job.spelling,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "spelling", $$v)
                      },
                      expression: "job.spelling"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Yes")))]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticStyle: { width: "fit-content", "min-width": "1540px" } },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.manifestInformation"))),
                    _c("i", {
                      staticClass: "el-icon-warning icon-tip",
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = true
                        }
                      }
                    })
                  ]),
                  _c(
                    "el-form",
                    {
                      staticStyle: {
                        "margin-left": "20px",
                        "margin-top": "5px"
                      },
                      attrs: { inline: "", "label-position": "left" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.manifestChannel") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: !_vm.isEdit || _vm.isSent },
                              on: { change: _vm.changeChannel },
                              model: {
                                value: _vm.localChannelDisplay,
                                callback: function($$v) {
                                  _vm.localChannelDisplay = $$v
                                },
                                expression: "localChannelDisplay"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.CargoWare")))
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.EDISend")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              Object.keys(_vm.job).length > 0
                ? _c("booking-manifest-info", {
                    ref: "bookingManifestBaseInfo",
                    attrs: {
                      "manifest-infos": _vm.manifestInfos,
                      "manifest-info": _vm.manifestInfo,
                      job: _vm.job,
                      "is-edit": _vm.isEdit,
                      action: _vm.action,
                      context: _vm.context,
                      channel: _vm.localChannel
                    },
                    on: {
                      "update:manifestInfos": function($event) {
                        _vm.manifestInfos = $event
                      },
                      "update:manifest-infos": function($event) {
                        _vm.manifestInfos = $event
                      },
                      "update:manifestInfo": function($event) {
                        _vm.manifestInfo = $event
                      },
                      "update:manifest-info": function($event) {
                        _vm.manifestInfo = $event
                      },
                      "update:channel": function($event) {
                        _vm.localChannel = $event
                      },
                      handleCarrier: function($event) {
                        return _vm.handleCarrier()
                      },
                      handleReceipt: function($event) {
                        return _vm.handleReceipt("receiptLog")
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
                  ]),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "5px", height: "28px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.copyCustomerShippingInformation }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_CopyCustomerShippingInformation"
                              )
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("booking-format-address", {
                ref: "bookingFormatAddress",
                attrs: {
                  job: _vm.job,
                  "manifest-info": _vm.manifestInfo,
                  "manifest-infos": _vm.manifestInfos,
                  "is-editing": _vm.isEdit && !_vm.isCfmState,
                  "is-add-spelling": _vm.job.spelling,
                  "is-sea-house-channel": _vm.isSeaHouseChannel,
                  "is-wse-channel": _vm.isWseChannel,
                  "is-ronge-tong": _vm.isRongeTong,
                  "special-character-check": _vm.specialCharacterCheck
                },
                on: {
                  "update:manifestInfo": function($event) {
                    _vm.manifestInfo = $event
                  },
                  "update:manifest-info": function($event) {
                    _vm.manifestInfo = $event
                  },
                  "update:manifestInfos": function($event) {
                    _vm.manifestInfos = $event
                  },
                  "update:manifest-infos": function($event) {
                    _vm.manifestInfos = $event
                  },
                  "update:isSeaHouseChannel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  },
                  "update:is-sea-house-channel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  },
                  "update:isWseChannel": function($event) {
                    _vm.isWseChannel = $event
                  },
                  "update:is-wse-channel": function($event) {
                    _vm.isWseChannel = $event
                  },
                  "update:isRongeTong": function($event) {
                    _vm.isRongeTong = $event
                  },
                  "update:is-ronge-tong": function($event) {
                    _vm.isRongeTong = $event
                  },
                  cleanUpAll: _vm.cleanUpAll
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
              ]),
              _c("booking-manifest-goods-info", {
                ref: "bookingManifestGoodsInfo",
                attrs: {
                  job: _vm.job,
                  "manifest-info": _vm.manifestInfo,
                  "is-edit": _vm.isEdit,
                  "is-editing": _vm.isEdit && !_vm.isCfmState,
                  "lcl-view": false,
                  "is-or-not-display-so-no": true,
                  "is-add-spelling": _vm.job.spelling,
                  "is-sea-house-channel": _vm.isSeaHouseChannel,
                  "is-wse-channel": _vm.isWseChannel,
                  "is-ronge-tong": _vm.isRongeTong,
                  channel: _vm.localChannel,
                  "show-combined-manifest": _vm.combinedManifest,
                  "special-character-check": _vm.specialCharacterCheck,
                  "vgm-required-input": _vm.vgmRequiredInput,
                  "is-uppercase-by-config": _vm.isUppercaseByConfig
                },
                on: {
                  "update:isSeaHouseChannel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  },
                  "update:is-sea-house-channel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  },
                  "update:isWseChannel": function($event) {
                    _vm.isWseChannel = $event
                  },
                  "update:is-wse-channel": function($event) {
                    _vm.isWseChannel = $event
                  },
                  "update:isRongeTong": function($event) {
                    _vm.isRongeTong = $event
                  },
                  "update:is-ronge-tong": function($event) {
                    _vm.isRongeTong = $event
                  },
                  "update:channel": function($event) {
                    _vm.localChannel = $event
                  },
                  soNoChange: _vm.soNoChangeHandler,
                  reload: _vm.reload
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.vgmRequiredInput,
                  expression: "vgmRequiredInput"
                }
              ],
              staticClass: "section"
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.VgmInfo")))
              ]),
              _c("booking-manifest-vgm-info", {
                attrs: {
                  job: _vm.job,
                  "manifest-info": _vm.manifestInfo,
                  "is-sea-house-channel": _vm.isSeaHouseChannel,
                  "is-editing": _vm.isEdit && !_vm.isCfmState
                },
                on: {
                  "update:isSeaHouseChannel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  },
                  "update:is-sea-house-channel": function($event) {
                    _vm.isSeaHouseChannel = $event
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.copyDialog.visible,
            title: _vm.$t("Message.ManifestLink"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.copyDialog, "visible", $event)
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.copyDialog.url))]),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "12", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleClipboard(_vm.copyDialog.url, $event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "13" },
                  on: {
                    click: function($event) {
                      _vm.copyDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("manifest-invitation-dialog", {
        attrs: {
          visible: _vm.inviteDialog.visible,
          "invitation-type": _vm.inviteDialog.invitationType,
          job: _vm.job,
          "manifest-info": _vm.manifestInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.inviteDialog, "visible", $event)
          }
        }
      }),
      _c("pre-shipping-bill-dialog", {
        attrs: {
          visible: _vm.preShippingBillDialog.visible,
          title: _vm.preShippingBillDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.preShippingBillDialog, "visible", $event)
          },
          prePlanBookingToVgm: _vm.prePlanBookingToVgm,
          reload: _vm.reload
        }
      }),
      _c("manifest-info-log-dialog", {
        attrs: {
          visible: _vm.manifestInfoLogDialog.visible,
          "manifest-info-uuid": _vm.manifestInfo.uuid,
          "is-sea-house-channel":
            _vm.isSeaHouseChannel || _vm.isWseChannel || _vm.isRongeTong
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.manifestInfoLogDialog, "visible", $event)
          }
        }
      }),
      _vm.receiptLogDialog.visible
        ? _c("edi-feed-back-state-title-dialog", {
            attrs: {
              visible: _vm.receiptLogDialog.visible,
              "is-sea-house-channel":
                _vm.isSeaHouseChannel || _vm.isWseChannel || _vm.isRongeTong,
              "manifest-info-uuid": _vm.manifestInfo.uuid,
              "active-tab": _vm.receiptLogDialog.activeTab,
              job: _vm.job
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.receiptLogDialog, "visible", $event)
              },
              "update:activeTab": function($event) {
                return _vm.$set(_vm.receiptLogDialog, "activeTab", $event)
              },
              "update:active-tab": function($event) {
                return _vm.$set(_vm.receiptLogDialog, "activeTab", $event)
              }
            }
          })
        : _vm._e(),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.selectorDialog.visible,
          title: _vm.selectorDialog.title,
          "row-data": _vm.selectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectorDialog, "visible", $event)
          },
          selected: _vm.selectorDialogCallback
        }
      }),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.selectedApiCallback
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "error-log": _vm.errorLogDialog.errorLog
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "85px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContainerNo") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.SealNo") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContainerSize") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                  }
                },
                [_c("el-input", { attrs: { type: "textarea", rows: 2 } })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Marks") } },
                [_c("el-input", { attrs: { type: "textarea", rows: 2 } })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "HSCode" } },
                [_c("el-input", { attrs: { type: "textarea", rows: 2 } })],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Package") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Quantity") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Weight") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Cubage") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "UN Code" } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.DangerousClass") } },
                [_c("el-input")],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ediStatus") } },
                [_c("el-input", { attrs: { disabled: true } })],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { attrs: { no: "14", type: "primary" } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.save")))
              ]),
              _c(
                "el-button",
                {
                  attrs: { no: "15" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("message-preview-dialog", {
        attrs: {
          visible: _vm.messagePreviewDialog.visible,
          params: _vm.messagePreviewDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "sea-house-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("SeaExport.MattersNeedingAttention")
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-txt" }, [
            _c("h6", [
              _c("i", { staticClass: "el-icon-warning icon-tip" }),
              _vm._v(_vm._s(_vm.$t("SeaExport.ExportReleaseNewRegulation")))
            ]),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.$t("SeaExport.ShanghaiAfterClearanceManifestContinuing")
                )
              )
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("SeaExport.YangshanAreaNovember152021")))
              ]),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("SeaExport.WaigaoqiaoAreaNovember222021")))
              ])
            ]),
            _c("h6", [
              _c("i", { staticClass: "el-icon-warning icon-tip" }),
              _vm._v(_vm._s(_vm.$t("SeaExport.GarbageCargoManifest")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("SeaExport.N1ActuallyShippedIfGarbage")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("SeaExport.N2ManifestMustBeDeletion")))
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("SeaExport.N3YuanOnTheManifest")))])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.hanldeRemindNext },
                  model: {
                    value: _vm.notRemindNextTime,
                    callback: function($$v) {
                      _vm.notRemindNextTime = $$v
                    },
                    expression: "notRemindNextTime"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.DontRemindMeAgain")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "can-operate",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CloseSpace")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.updateWsTjDialog.visible,
            title: _vm.$t("SeaExport.Prompt"),
            "close-on-click-modal": false,
            width: "340px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.updateWsTjDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "85px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Warehouse.ModifiedReason"),
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "195px" },
                      attrs: { no: "checklistStatus", placeholder: "" },
                      model: {
                        value: _vm.updateWsTjDialog.modifiedReason,
                        callback: function($$v) {
                          _vm.$set(_vm.updateWsTjDialog, "modifiedReason", $$v)
                        },
                        expression: "updateWsTjDialog.modifiedReason"
                      }
                    },
                    _vm._l(_vm.updateWsTjDialog.modifiedReasonList, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.code, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Warehouse.WsTjRemark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "195px" },
                    attrs: {
                      placeholder: _vm.$t("Warehouse.ModifiedWsTjTips"),
                      type: "textarea",
                      row: 5
                    },
                    model: {
                      value: _vm.updateWsTjDialog.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.updateWsTjDialog, "remark", $$v)
                      },
                      expression: "updateWsTjDialog.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toUpdateWsTj } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.updateWsTjDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.deleteWsTjDialog.visible,
            title: _vm.$t("SeaExport.Prompt"),
            width: "340px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.deleteWsTjDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "85px", "label-position": "left" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Warehouse.WsTjReason"), required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "195px" },
                      attrs: { no: "checklistStatus", placeholder: "" },
                      model: {
                        value: _vm.deleteWsTjDialog.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.deleteWsTjDialog, "reason", $$v)
                        },
                        expression: "deleteWsTjDialog.reason"
                      }
                    },
                    _vm._l(_vm.updateWsTjDialog.modifiedReasonList, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.code, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Warehouse.WsTjDelRemark") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "195px" },
                    attrs: {
                      placeholder: _vm.$t("Warehouse.ModifiedWsTjTips"),
                      type: "textarea",
                      row: 5
                    },
                    model: {
                      value: _vm.deleteWsTjDialog.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.deleteWsTjDialog, "remark", $$v)
                      },
                      expression: "deleteWsTjDialog.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toDeleteWsTj } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.deleteWsTjDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("carrier-agent-data-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.carrierAgentDialog.visible,
            expression: "carrierAgentDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.carrierAgentDialog.visible,
          "row-data": [].concat(_vm.manifestInfo),
          agent: _vm.carrierAgentDialog.agent
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.carrierAgentDialog, "visible", $event)
          },
          close: function($event) {
            _vm.carrierAgentDialog.visible = false
          }
        }
      }),
      _vm.copyShippingInfoDialog.visible
        ? _c("customer-shipping-information-copy-dialog", {
            attrs: {
              job: _vm.job,
              visible: _vm.copyShippingInfoDialog.visible,
              "is-sea-house-channel": _vm.isSeaHouseChannel
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.copyShippingInfoDialog, "visible", $event)
              },
              selected: _vm.selectAddressInfo
            }
          })
        : _vm._e(),
      _c("service-Information-Dialog-New", {
        attrs: { visible: _vm.serviceInformationDialogNew.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.serviceInformationDialogNew, "visible", $event)
          }
        }
      }),
      _c("choose-sea-house-del-dialog", {
        attrs: {
          "manifest-goods": _vm.chooseSeaHouseDelDialog.manifestGoods,
          "manifest-info-uuid": _vm.manifestInfo.uuid,
          "is-wse-channel": _vm.isWseChannel,
          "is-ronge-tong": _vm.isRongeTong,
          "container-no-map": _vm.chooseSeaHouseDelDialog.containerNoMap,
          visible: _vm.chooseSeaHouseDelDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chooseSeaHouseDelDialog, "visible", $event)
          },
          reload: _vm.reload
        }
      }),
      _c("modify-manifest-status-dialog", {
        attrs: {
          visible: _vm.modifyManifestStatusDialog.visible,
          "manifest-info": _vm.manifestInfo,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.modifyManifestStatusDialog, "visible", $event)
          },
          reload: _vm.reload
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.updateConfigDialog.visible,
            title: _vm.updateConfigDialog.title,
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.updateConfigDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "70px" } },
            [
              _c("br"),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("SeaExport.Vessel"), required: "" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.updateConfigDialog.vessel,
                      callback: function($$v) {
                        _vm.$set(_vm.updateConfigDialog, "vessel", $$v)
                      },
                      expression: "updateConfigDialog.vessel"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("SeaExport.Voyage"), required: "" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.updateConfigDialog.voyage,
                      callback: function($$v) {
                        _vm.$set(_vm.updateConfigDialog, "voyage", $$v)
                      },
                      expression: "updateConfigDialog.voyage"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("br"),
          _c("br"),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.updateConfig } },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirmUpdate")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }